import { useState } from 'react'

// local imports
import PoolVehicleService from 'service/PoolVehicleService'
import { IFilteredPoolVehicleList } from 'types/PoolVehicleType'

export default function useGetPoolVehicleList() {
  const [vehicles, setVehicles] = useState<IFilteredPoolVehicleList[] | []>([])
  const [loading, setLoading] = useState(false)

  /* Get Pool Vehicles List */
  const getPoolVehiclesList = (data: any) => {
    setLoading(true)
    PoolVehicleService.getPoolVehicleFilteredList(data)
      .then((r) => setVehicles(r.data))
      .finally(() => setLoading(false))
  }

  return { vehicles, getPoolVehiclesList, loading }
}
